import { zRoutePointSchemaCreateDto, } from "@/types/routePoint/routePoint.dto";
import { supabase } from "@/utils/supabase";
export class RouteCalculationService {
    constructor() { }
    /**
     * Асинхронная функция просчета данных для точек маршрута
     * Использует edge function для расчета времен
     * @param startTime - Время начала маршрута (ISODate)
     * @param routePoints - Массив точек маршрута
     * @returns Promise с обновленными данными точек маршрута
     */
    async calculateRoutePointTimes(startTime, routePoints, withGeometry = false) {
        try {
            const { data, error } = await supabase().functions.invoke("route-calculation", {
                body: {
                    startTime,
                    routePoints,
                    ...(withGeometry ? { withGeometry: true } : {}),
                },
            });
            if (error) {
                throw new Error(`Ошибка расчета маршрута: ${error.message}`);
            }
            return zRoutePointSchemaCreateDto.array().parse(data);
        }
        catch (error) {
            console.error("Ошибка при вызове edge function route-calculation:", error);
            throw error;
        }
    }
    /**
     * Получить геометрию маршрута (polyline) через edge function route-geometry.
     * Возвращает массив [lat, lon] пар.
     * При ошибке выбрасывает исключение — обработка на стороне вызывающего кода.
     * @param points - Массив точек маршрута с координатами
     * @returns Promise с массивом [lat, lon] пар
     */
    async getRouteGeometry(points) {
        const { data, error } = await supabase().functions.invoke("route-geometry", {
            body: { waypoints: points },
        });
        if (error)
            throw error;
        return data.geometry ?? [];
    }
}
export const routeCalculationService = new RouteCalculationService();
